import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent, SxProps, Theme } from '@mui/material';

interface YearSelectorProps {
  value: number;
  onChange: (year: number) => void;
  years: number[];
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

const YearSelector: React.FC<YearSelectorProps> = ({ value, onChange, years, disabled = false, sx }) => {
  const handleChange = (event: SelectChangeEvent<number>) => {
    onChange(event.target.value as number);
  };

  return (
    <FormControl sx={{ minWidth: 200, mb: 0, '& .MuiInputBase-root': { height: 54 }, ...sx }} size="small" disabled={disabled}>
      <InputLabel id="year-selector-label">Year</InputLabel>
      <Select
        labelId="year-selector-label"
        value={value}
        label="Year"
        onChange={handleChange}
      >
        {years.map((year) => (
          <MenuItem key={year} value={year}>
            {year}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default YearSelector;

